import * as ActionTypes from '../actions/index';
import {fromJS} from "immutable";
import {createReducer} from "./index";
import { PDF_TYPES } from '../helpers/constants/productAttachmentTypes';

const INITIAL_STATE_IS_PUBLIC = fromJS({
  [PDF_TYPES.PDF_FRONTPAGE_ONE]: false,
  [PDF_TYPES.PDF_FRONTPAGE_TWO]: false,
  [PDF_TYPES.PDF_FRONTPAGE_THREE]: false,
  [PDF_TYPES.PDF_FRONTPAGE_FOUR]: false,
  [PDF_TYPES.PDF_FRONTPAGE_FIVE]: false,
});

const INITIAL_STATE = fromJS({
  fetching: false,
  pdfs: [],
  total: 0,
  page: 1,
  rowsPerPage: 10,
  orderBy: 0,
  order: 'desc',
  errorMessage: undefined,
  changedPdf: undefined,
  pdfsEdit: [],
  isPublic: {
    [PDF_TYPES.PDF_FRONTPAGE_ONE]: false,
    [PDF_TYPES.PDF_FRONTPAGE_TWO]: false,
    [PDF_TYPES.PDF_FRONTPAGE_THREE]: false,
    [PDF_TYPES.PDF_FRONTPAGE_FOUR]: false,
    [PDF_TYPES.PDF_FRONTPAGE_FIVE]: false,
  }
});

function getPdfs(state, action) {
  return state.set('fetching', true);
}

function getPdfsSuccess(state, action) {
  return state
    .set('fetching', false)
    .set('pdfs', fromJS(action.payload.body))
}

function getPdfsFailed(state, action) {
  return state.set('fetching', false);
}

function countPdfs(state, action) {
  return state;
}

function countPdfsSuccess(state, action) {
  return state
    .set('total', action.payload.body.count)
}

function countPdfsFailed(state, action) {
  return state;
}

function uploadPdfs(state, action) {
  return state;
}

function uploadPdfsSuccess(state, action) {
  return state
    .set('tempImage', undefined)
}

function uploadPdfsFailed(state, action) {
  return state;
}

function clearPdfsForm(state, action) {
  return state
    .set('isPublic', INITIAL_STATE_IS_PUBLIC)
}

function editPdf(state, action) {
  return state;
}

function editPdfFailed(state, action) {
  return state;
}

function storeIsPublic(state, action) {
  return state.setIn(['isPublic', action.payload.pdf], action.payload.checked)
}

function storeIsPublicForAll(state, action) {
  return state.set('isPublic', fromJS(action.payload));
}

export const pdfs = createReducer(INITIAL_STATE, {
  [ActionTypes.GET_PDFS]: getPdfs,
  [ActionTypes.GET_PDFS_SUCCESS]: getPdfsSuccess,
  [ActionTypes.GET_PDFS_FAILED]: getPdfsFailed,
  [ActionTypes.COUNT_PDFS]: countPdfs,
  [ActionTypes.COUNT_PDFS_SUCCESS]: countPdfsSuccess,
  [ActionTypes.COUNT_PDFS_FAILED]: countPdfsFailed,
  [ActionTypes.UPLOAD_PDFS]: uploadPdfs,
  [ActionTypes.UPLOAD_PDFS_SUCCESS]: uploadPdfsSuccess,
  [ActionTypes.UPLOAD_PDFS_FAILED]: uploadPdfsFailed,
  [ActionTypes.CLEAR_PDFS_FORM]: clearPdfsForm,
  [ActionTypes.EDIT_PDFS]: editPdf,
  [ActionTypes.EDIT_PDFS_FAILED]: editPdfFailed,
  [ActionTypes.STORE_IS_PUBLIC]: storeIsPublic,
  [ActionTypes.STORE_IS_PUBLIC_FOR_ALL_PDFS]: storeIsPublicForAll,
});



// WEBPACK FOOTER //
// ./src/reducers/pdfs.js